import { render, staticRenderFns } from "./AlertaVigenciaC3PersonalComponent.vue?vue&type=template&id=400bfd06"
import script from "./AlertaVigenciaC3PersonalComponent.vue?vue&type=script&lang=js"
export * from "./AlertaVigenciaC3PersonalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports